/**
 * 令牌本地存储（记住登录默认 7 天，否则仅当前会话）
 */
const TOKEN_KEY = 'wordapp:access-token'
const REFRESH_KEY = 'wordapp:refresh-token'
const EXPIRE_KEY = 'wordapp:token-expire-at'

/** 记住登录天数 */
export const REMEMBER_DAYS = 7

export interface TokenPair {
  accessToken: string
  refreshToken: string
}

function safeGet(key: string): string {
  try {
    return localStorage.getItem(key) ?? ''
  } catch {
    return ''
  }
}

function safeSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    /* 隐私模式下忽略 */
  }
}

function safeRemove(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}

/**
 * 保存令牌；remember=true 时 7 天有效，否则写入 sessionStorage 语义（这里用过期时间控制）
 */
export function saveToken(pair: TokenPair, remember = false): void {
  safeSet(TOKEN_KEY, pair.accessToken)
  safeSet(REFRESH_KEY, pair.refreshToken)
  const expireAt = remember
    ? Date.now() + REMEMBER_DAYS * 24 * 60 * 60 * 1000
    : Date.now() + 12 * 60 * 60 * 1000
  safeSet(EXPIRE_KEY, String(expireAt))
}

export function getToken(): string {
  const token = safeGet(TOKEN_KEY)
  if (!token) return ''
  const expireAt = Number(safeGet(EXPIRE_KEY) || 0)
  if (expireAt && Date.now() > expireAt) {
    clearAuth()
    return ''
  }
  return token
}

export function getRefreshToken(): string {
  return safeGet(REFRESH_KEY)
}

export function isTokenExpired(): boolean {
  const expireAt = Number(safeGet(EXPIRE_KEY) || 0)
  return expireAt > 0 && Date.now() > expireAt
}

export function clearAuth(): void {
  safeRemove(TOKEN_KEY)
  safeRemove(REFRESH_KEY)
  safeRemove(EXPIRE_KEY)
}
